// ==========================================================================
// WORKIN CHIX EVENTS — Content & Data
// All copy and structured data live here so it can be lifted straight into
// Wix sections later. Keep edits clean and Wix-friendly.
// ==========================================================================

export const BRAND = {
  name: "Workin Chix Events",
  shortName: "Workin Chix",
  monogram: "WC",
  tagline: "Curated Pop-Up Markets",
  location: "Bay Area, California",
  email: "hello@workinchixevents.com", // PLACEHOLDER — replace before launch
  // PLACEHOLDER social handles
  socials: {
    instagram: "https://instagram.com/workinchixevents",
    tiktok: "https://www.tiktok.com/@workinchixevents",
    email: "mailto:hello@workinchixevents.com",
  },
};

export const VENDOR_PAYMENTS = [
  {
    label: "Cash App",
    handle: "$GiaLH",
    url: "https://cash.app/$GiaLH",
    note: "Tap to pay your vendor fee via Cash App.",
  },
  {
    label: "Venmo",
    handle: "Tap to open Venmo",
    url: "https://venmo.com/code?user_id=2033562048004096466&created=1766981018",
    note: "Send your vendor fee via Venmo.",
  },
  {
    label: "PayPal",
    handle: "eluxurie@yahoo.com",
    url: "https://www.paypal.com/myaccount/transfer/homepage/pay?recipient=eluxurie@yahoo.com",
    note: "Pay your vendor fee via PayPal.",
  },
];

// Upcoming Markets — details TBA (client to update with confirmed listings)
export const UPCOMING_EVENTS = [
  {
    id: "market-01",
    name: "TBA",
    date: "Date TBD",
    time: "Time TBD",
    location: "TBA",
    address: "",
    cover: "/assets/gallery/oakland/oak-04.png",
    vendorCount: "TBA",
    highlights: [],
    rsvpUrl: "#rsvp",
    status: "Coming Soon",
    description: "Details to be announced. Stay tuned.",
  },
  {
    id: "market-02",
    name: "TBA",
    date: "Date TBD",
    time: "Time TBD",
    location: "TBA",
    address: "",
    cover: "/assets/gallery/sf/sf-06.png",
    vendorCount: "TBA",
    highlights: [],
    rsvpUrl: "#rsvp",
    status: "Coming Soon",
    description: "Details to be announced. Stay tuned.",
  },
  {
    id: "market-03",
    name: "TBA",
    date: "Date TBD",
    time: "Time TBD",
    location: "TBA",
    address: "",
    cover: "/assets/gallery/sf/sf-12.png",
    vendorCount: "TBA",
    highlights: [],
    rsvpUrl: "#rsvp",
    status: "Coming Soon",
    description: "Details to be announced. Stay tuned.",
  },
];

// Past Events — surfaced on Gallery + linked to Pixieset
export const PAST_EVENTS = [
  {
    id: "workinchix-event-2",
    name: "Workin Chix Event 2",
    date: "February 14, 2026",
    location: "San Francisco, CA",
    cover: "/assets/gallery/sf/sf-17.png",
    pixiesetUrl: "https://kalvry.pixieset.com/workinchixevent2/",
    photoCount: 17,
  },
  {
    id: "workinchix-oakland",
    name: "Workin Chix Events — Oakland",
    date: "January 31, 2026",
    location: "Oakland, CA",
    cover: "/assets/gallery/oakland/oak-17.png",
    pixiesetUrl: "https://kalvry.pixieset.com/workinchixeventsoakland/",
    photoCount: 17,
  },
];

// Gallery — pulled samples from both Pixieset collections (saved as .png in /public)
export const GALLERY_IMAGES = [
  ...Array.from({ length: 16 }, (_, i) => ({
    src: `/assets/gallery/sf/sf-${String(i + 1).padStart(2, "0")}.png`,
    alt: `Workin Chix Event 2 — photo ${i + 1}`,
    event: "Workin Chix Event 2",
  })),
  ...Array.from({ length: 16 }, (_, i) => ({
    src: `/assets/gallery/oakland/oak-${String(i + 1).padStart(2, "0")}.png`,
    alt: `Workin Chix Events Oakland — photo ${i + 1}`,
    event: "Workin Chix Events Oakland",
  })),
];

// Vendor categories welcomed
export const VENDOR_CATEGORIES = [
  "Apparel + Vintage",
  "Jewelry + Accessories",
  "Skincare + Beauty",
  "Candles + Home",
  "Art + Prints",
  "Food + Beverage",
  "Wellness + Apothecary",
  "Books + Stationery",
];

// About page content
export const ABOUT = {
  eyebrow: "Our Story",
  headline:
    "Beautiful, safe, well-curated market days for the makers and the community that loves them.",
  paragraphs: [
    "Workin Chix Events was built on a simple idea: small businesses deserve a stage as beautiful as the work they make. We design pop-up market days across the Bay Area that feel less like trade shows and more like neighborhood moments — soft lighting, considered vendors, music you actually want to hear, and the kind of crowd that comes ready to shop, talk and stay a while.",
    "We work with vendors hand-to-hand. Every market is curated, every layout intentional, every detail chosen so that creatives, makers and small business owners can show up, sell their work and feel taken care of.",
    "For the community, our markets are an invitation — to discover something new, support someone local, and spend an afternoon (or an evening) in a space that's been made for you.",
  ],
  pillars: [
    {
      title: "Curated",
      copy: "Every vendor is hand-selected. Every market is composed.",
    },
    {
      title: "Community-first",
      copy: "We build markets the way our neighborhoods deserve.",
    },
    {
      title: "Bay Area-rooted",
      copy: "From Oakland to SF to Berkeley — proudly local, always.",
    },
  ],
};

// Homepage copy blocks
export const HOME = {
  heroEyebrow: "Curated Pop-Up Markets · Bay Area",
  heroTitle: "Where small business meets a big afternoon.",
  heroSub:
    "Workin Chix Events hosts curated pop-up markets, vendor events and community shopping experiences across the Bay Area.",
  manifesto:
    "We design market days the way we'd want to spend a Saturday — beautiful, easy, full of people doing what they love, surrounded by people who love it too.",
  ctaShop: "See Upcoming Markets",
  ctaVendor: "Apply as a Vendor",
};

// Contact page
export const CONTACT = {
  eyebrow: "Say hello",
  headline: "Let's build something together.",
  intro:
    "Vendor questions, partnership ideas, venue collaborations or just a hello — we'd love to hear from you.",
  channels: [
    { label: "General", value: "hello@workinchixevents.com", href: "mailto:hello@workinchixevents.com" },
    { label: "Vendors", value: "vendors@workinchixevents.com", href: "mailto:vendors@workinchixevents.com" },
    { label: "Partners", value: "partners@workinchixevents.com", href: "mailto:partners@workinchixevents.com" },
  ],
};

// Hero placeholder video poster (until client sends final cut)
// Until the finalized full-frame Market video is ready, we cross-fade
// real event cover photos shot by Kalvry — the most vibrant + representative.
export const HERO_VIDEO = {
  posterImage: "/assets/gallery/sf/sf-17.png",
  src: "",
  rotation: [
    "/assets/gallery/sf/sf-17.png",       // SF event cover
    "/assets/gallery/sf/sf-10.png",       // vibrant vendor booth color
    "/assets/gallery/oakland/oak-17.png", // Oakland event cover
    "/assets/gallery/sf/sf-13.png",       // wide crowd shot
    "/assets/gallery/oakland/oak-09.png", // bright in-market shot
  ],
};
